import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import { GridExpandMoreIcon } from '@mui/x-data-grid';
import React from 'react';
import { usePostCodes } from '../../../../Aemter/hooks';
import { PostcodeSearch } from '../../../../Clients/AddressTab/PostcodeSearch';
import { IPostcode } from '../../../../Interfaces/IPostcode';
import { IRealEstate } from '../../../../Interfaces/IRealEstate';
import { handlePostcode } from '../../../../services/dialog.service';
import { MapSearch } from '../../../PurchaseContract/RealEstate/MapSearch/MapSearch';

interface IProps {
  currentObject: IRealEstate;
  setCurrentObject: React.Dispatch<React.SetStateAction<IRealEstate>>;
  marginTop?: number;
}

export const MortgageRealEstateAddress: React.FC<IProps> = ({
  currentObject,
  setCurrentObject,
  marginTop,
}) => {
  const { postcodes, isLoadingPostcodes } = usePostCodes();

  const setPostcodeObjectWrapper = (
    postcodeObject: IPostcode | null | undefined
  ) => {
    if (postcodeObject) {
      setCurrentObject({
        ...currentObject,
        idPostcode: postcodeObject.idPostcode,
        Postcode: postcodeObject.Postcode,
        City: postcodeObject.City,
      } as IRealEstate);
    }
  };

  return (
    <>
      <Typography
        variant='h5'
        sx={{ mt: marginTop === undefined ? 2 : marginTop, mb: 1 }}
      >
        Anschrift des Objektes
        <Typography mt={2}>
          Bitte geben Sie die Adresse des Objektes an.
        </Typography>
      </Typography>
      <Grid container spacing={2}>
        <Grid item sm={5}>
          <TextField
            label='Straße'
            size='small'
            required
            fullWidth
            value={currentObject.Street === null ? '' : currentObject.Street}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setCurrentObject({
                ...currentObject,
                Street: event.target.value,
              })
            }
          />
        </Grid>
        <Grid item sm={5}>
          <TextField
            label='Adresszusatz'
            size='small'
            fullWidth
            value={
              currentObject.StreetAditional === null
                ? ''
                : currentObject.StreetAditional
            }
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setCurrentObject({
                ...currentObject,
                StreetAditional: event.target.value,
              })
            }
          />
        </Grid>
        <Grid item sm={2}>
          <TextField
            label='Hausnummer'
            size='small'
            required
            fullWidth
            value={
              currentObject.StreetNr === null ? '' : currentObject.StreetNr
            }
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setCurrentObject({
                ...currentObject,
                StreetNr: event.target.value,
              })
            }
          />
        </Grid>
        <Grid item sm={12}>
          <PostcodeSearch
            key={handlePostcode(currentObject)?.idPostcode}
            postcodeObject={handlePostcode(currentObject)}
            updatePostcodeObject={setPostcodeObjectWrapper}
            required
          />
        </Grid>

        <Grid item sm={12}>
          <Box sx={{ mt: 1 }} />
        </Grid>

        <Grid item sm={12}>
          <Box sx={{ mt: 1 }} />
        </Grid>

        <Grid item sm={12}>
          <Accordion>
            <AccordionSummary
              expandIcon={<GridExpandMoreIcon />}
              aria-controls='panel1a-content'
              id='panel1a-header'
            >
              <Typography>Adresse / Koordinaten suchen</Typography>
            </AccordionSummary>

            <AccordionDetails>
              {!isLoadingPostcodes && (
                <MapSearch
                  options={postcodes}
                  setMapSearch={newValue =>
                    setCurrentObject(x => ({ ...x, newValue }))
                  }
                />
              )}
            </AccordionDetails>
          </Accordion>
        </Grid>
      </Grid>
    </>
  );
};
